import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldCheckbox = ({
  id,
  label,
  value,
  handleChange,
  readOnly,
  hidden,
}) => {
  return (
    <S.Container className={hidden ? "hidden" : "visible"}>
      <S.Label>{label}</S.Label>
      <S.CheckboxContainer>
        <S.Input
          type="checkbox"
          value={value}
          checked={value}
          disabled={readOnly}
          onChange={(e) => handleChange(id, e.target.checked)}
        />
        <input className="hidden" name={id} value={value} readOnly />
      </S.CheckboxContainer>
    </S.Container>
  );
};

FieldCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.bool,
  handleChange: PropTypes.func,
  readOnly: PropTypes.bool,
  hidden: PropTypes.bool,
};
